import React, { PureComponent } from 'react';
import Label from '../../../../components/svg/Label';
import DatabaseModal from '../../Editors/DatabaseModal';
import { getHexColorString, getOpacityFromRgba } from '../../../../helpers/helpers';
import TextAreaField from '../../../../components/TextAreaField';
import FieldWrapper from './FieldWrapper';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';
import { DataSourceOrigin } from '../../../../helpers/constants';

export interface DatabaseFieldProps {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  tableName?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  align?: string;
  foregroundColor: TypeMePlease;
  backgroundColor: TypeMePlease;
  fontName?: string;
  fontSize?: number;
  padding?: number;
  editable: boolean;
  value?: string;
  allowOther: boolean;
  dataSource?: string;
  dataSourceOrigin?: DataSourceOrigin;
  displayColumn?: string;
  filter?: string;
  wrapText: boolean;
}

export default class DatabaseField extends PureComponent<DatabaseFieldProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.mouseDown = this.mouseDown.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleValueChanged = this.handleValueChanged.bind(this);

    this.state = { dropdownOpen: false };
  }

  mouseDown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  handleModalClose() {
    this.setState({ dropdownOpen: false });
  }

  handleValueChanged(data) {
    this.props.valueUpdated({ value: data });
    this.setState({ dropdownOpen: false });
  }

  render() {
    let databaseModal = null;

    if (this.state.dropdownOpen) {
      databaseModal = (
        <DatabaseModal
          open
          onClose={this.handleModalClose}
          allowOther={this.props.allowOther}
          value={this.props.value}
          onChanged={this.handleValueChanged}
          dataSourceName={this.props.dataSource}
          dataSourceOrigin={this.props.dataSourceOrigin}
          displayColumn={this.props.displayColumn}
          filter={this.props.filter}
          tableName={this.props.tableName}
        />
      );
    }

    let innerElement: JSX.Element;
    if (this.props.wrapText) {
      innerElement = (
        <TextAreaField
          text={this.props.value}
          fontName={this.props.fontName}
          fontSize={this.props.fontSize}
          width={this.props.w}
          height={this.props.h}
          align={this.props.align}
          padding={this.props.padding}
          foregroundColor={getHexColorString(this.props.foregroundColor)}
          foregroundColorOpacity={getOpacityFromRgba(this.props.foregroundColor)}
        />
      );
    } else {
      innerElement = (
        <Label
          text={this.props.value}
          fontName={this.props.fontName}
          fontSize={this.props.fontSize}
          width={this.props.w}
          align={this.props.align}
          padding={this.props.padding}
          foregroundColor={getHexColorString(this.props.foregroundColor)}
          foregroundColorOpacity={getOpacityFromRgba(this.props.foregroundColor)}
        />
      );
    }

    return (
      <FieldWrapper
        onMouseDown={this.mouseDown}
        x={this.props.x}
        y={this.props.y}
        w={this.props.w}
        h={this.props.h}
        backgroundColor={this.props.backgroundColor}
        editable={this.props.editable}
        id={this.props.id}
        fieldId={this.props.fieldId}
      >
        {innerElement}
        <ErrorBoundary>{databaseModal}</ErrorBoundary>
      </FieldWrapper>
    );
  }
}
